module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ack",
      "epub:type": "acknowledgments",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "FMH",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page xiii. ",
      "epub:type": "pagebreak",
      "id": "pg_xiii",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("acknowledgments")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTNI"
  }, [_vm._v("Thank you to everyone who read this in the early stages. All my love and gratitude go to my mother, Claudia, for all her support, always: and to my sister, Jemima, for her advice and feedback.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("Deep love and thanks to Emma, of course, for everything.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("My heartfelt thanks to Max Schaefer, who gave me invaluable criticisms, hours of word-processing help, and great friendship during a generally rubbish year.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("I can never thank Mic Cheetham enough. I am incredibly lucky to have her on my side. And thanks to all at Macmillan, particularly Peter Lavery, and at Tor, particularly Brian Cholfin and Jenna Felice.")]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_vm._v("I owe too many writers and artists to mention, but respect is especially due to Two Fingers and James T. Kirk for their novel "), _c('i', [_vm._v("Junglist.")]), _vm._v(" They blazed a trail. Many thanks also to Iain Sinclair for generously letting me keep the metaphor I accidently stole from him. Jake Pilikian introduced me to Drum and Bass music and changed my life. Big up to all the DJs and Crews who provided a soundtrack. Awe and gratitude especially to A Guy Called Gerald for the sublime "), _c('i', [_vm._v("Gloc")]), _vm._v(": old, now, but still the most terrifying slab of guerrilla bass ever committed to vinyl. Rewind.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c150588c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0